import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const JixiaoList = styled.div`
  .year {
    backgroundcolor: #fff;
    // padding: 10px 20px 10px 20px;
  }
  .year ul {
    list-style: none;
    padding: 10px 20px 10px 20px;
    margin: 0;
  }
  .year li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .year p {
    display: flex;
    justify-content: space-between;
  }
`;
interface monthArray {
  考核时间: string;
  发布时间: string;
  考核通知标题: string;
  vSheetId: string;
}
interface yearArray {
  考核时间: string;
  发布时间: string;
  考核通知标题: string;
  vSheetId: string;
}
export default function JxAssessment() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [monthNoticeList, setMonthNoticeList] = useState<monthArray[]>([]);
  const [yearNoticeList, setYearNoticeList] = useState<yearArray[]>([]);
  const [keyword, setKeyword] = useState<string>();
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    instance
      .get(
        `/oa/examMonth/getMonthNoticeExecuteList?permissionType=` + "staffMe"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setMonthNoticeList(resp.data.Data.data);
        }
      });
  }, []);
  useEffect(() => {
    instance
      .get(
        `/oa/examYear/getYearNoticeExecuteStaffList?permissionType=` + "staffMe"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setYearNoticeList(resp.data.Data.data);
        }
      });
  }, []);
  const tabs = [{ title: "月度绩效考核" }, { title: "年度绩效考核" }];
  // 月度绩效考核搜索
  const searchBarChange = useCallback((keyword) => {
    instance
      .get(
        `/oa/examMonth/getMonthNoticeExecuteList?mobileParam=` +
          keyword +
          "&permissionType=staffMe"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setMonthNoticeList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    instance
      .get(
        `/oa/examMonth/getMonthNoticeExecuteList?permissionType=` + "staffMe"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setMonthNoticeList(resp.data.Data.data);
        }
      });
  }, []);
  //年度绩效考核搜索
  const searchBarChange1 = useCallback((keyword1) => {
    instance
      .get(
        `/oa/examYear/getYearNoticeExecuteStaffList?mobileParam=` +
          keyword1 +
          "&permissionType=staffMe"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setYearNoticeList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch1 = useCallback(() => {
    instance
      .get(
        `/oa/examYear/getYearNoticeExecuteStaffList?permissionType=` + "staffMe"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setYearNoticeList(resp.data.Data.data);
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/index`);
                }}
              />
            }
          >
            绩效考核
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 月度绩效考核 */}
            <div
              //   style={{
              //     backgroundColor: "#fff",
              //     padding: "10px 20px 10px 20px",
              //   }}
              className="year"
            >
              <SearchBar
                value={keyword}
                onChange={(value) => setKeyword(value)}
                placeholder="请输入搜索年月"
                className="margin"
                onSubmit={() => {
                  searchBarChange(keyword);
                }}
                onCancel={() => {
                  noSearch();
                }}
              />
              <ul>
                {monthNoticeList.map((item) => (
                  <li>
                    <p>
                      <span>{item.考核时间.substr(0, 7)}</span>
                      <span>{item.发布时间}</span>
                    </p>
                    <p>
                      <span>{item.考核通知标题}</span>
                      <span
                        onClick={() => {
                          window.location.href =
                            "/hr/jxassessment/monthassessment?vSheetId=" +
                            item.vSheetId;
                        }}
                      >
                        详情&gt;
                      </span>
                    </p>
                  </li>
                ))}
              </ul>
              {monthNoticeList.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无更多数据</span>
                </div>
              )}
            </div>
            {/* 年度绩效考核 */}
            <div className="year">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入搜索年份"
                className="margin"
                onSubmit={() => {
                  searchBarChange1(keyword1);
                }}
                onCancel={() => {
                  noSearch1();
                }}
              />
              <ul>
                {yearNoticeList.map((item) => (
                  <li>
                    <p>
                      <span>{item.考核时间.substr(0, 4)}年</span>
                      <span>{item.发布时间}</span>
                    </p>
                    <p>
                      <span>{item.考核通知标题}</span>
                      <span
                        onClick={() => {
                          window.location.href =
                            "/hr/jxassessment/yearassessment?vSheetId=" +
                            item.vSheetId;
                        }}
                      >
                        详情&gt;
                      </span>
                    </p>
                  </li>
                ))}
              </ul>
              {yearNoticeList.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无更多数据</span>
                </div>
              )}
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
